import type { QuoteFile } from 'paintscout'

export function generateSrcSet({ file, svg, size }: { file: QuoteFile; svg?: boolean; size?: number }): string {
  const regex = /(.*amazonaws\.com)/
  if (!file.src.match(regex)) {
    return null
  }
  const base = file.src.match(regex)[1]
  const fileIndex = file.s3PublicKey.lastIndexOf('/')
  const fileName = file.s3PublicKey.slice(fileIndex)
  const id = fileName.split('.')[0]
  const idIndex = file.s3PublicKey.indexOf(id)
  const dist = file.s3PublicKey.slice(0, idIndex)

  // Svg url
  if (svg) {
    return base + `/${dist}` + id + '/svg' + fileName
  }

  // Singular size url
  if (size) {
    return base + `/${dist}` + id + `/${size}` + fileName
  }

  // Keep in sync w/ apps/api/src/services/task/image-resize/image-resize.ts
  const resizeWidths = [50, 300, 500, 700, 900, 1200]
  // Resized srcSet
  const lines = resizeWidths.map((width) => {
    return base + `/${dist}` + `${id}` + `/${width}` + `${fileName}` + ` ${width}w`
  })
  return lines.join(', ')
}
